import { render } from "./PaymentMethod.vue?vue&type=template&id=d0d5b418"
import script from "./PaymentMethod.js?vue&type=script&lang=js"
export * from "./PaymentMethod.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PaymentMethod.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageCheckout%2FOrderOverview%2FPaymentMethod%2FPaymentMethod.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__